import React, { Component } from 'react';
import * as api from '../../api/api';
import { connect } from 'react-redux';
import { Grid, GridCell } from 'rmwc/Grid';
import { Card } from 'rmwc/Card';
import { Typography } from 'rmwc/Typography';
import {Button} from 'rmwc/Button';
import ReactExport from "react-data-export";
import StatusMessage from '../../util/StatusMessage'

class AdminCouponAllocationStatus extends Component{

  constructor(props){
    super(props);
    this.state={
      allocatedCoupons: "",
      couponTrackExport: [],
      couponExport: [],
      couponExportdownloadDisable: true,
      couponTrackExportDownloadDisable: true,
      errorMsg: '',
    }
  }

  componentDidMount() {

    return api.adminCouponAllocationStatus(this.props.user.accessToken)
    .then((result) => {
      if(result.status === 'success'){
      this.setState({allocatedCoupons: result.data})
      }
    })
  }

  goBack = () => {
    this.props.history.push('/portal/app/admin/coupons')
  }

  handleCouponExport = () =>{
    let url = `admin/export/remaining/coupons`

    if(!this.state.couponExportdownloadDisable){
      this.setState({couponExportdownloadDisable: true }) 
    }

    api.getResponse(this.props.user.accessToken, url)
    .then((result) => {
      if (result.status === 'success'){
       this.setState({couponExport: result.data, couponExportdownloadDisable: false,  errorMsg: ''}) 
      }
      else if (result.status === 'error'){
        this.setState({errorMsg: result.message})
      }
    }).catch((err) => {
       this.setState({ errorMsg: 'Exception.Error in Fetching Details' })
    })
  }

  handleCouponTrackExport = () => {
    let url = `admin/list/of/coupon/codes/by/track`

    if(!this.state.couponTrackExportDownloadDisable){
      this.setState({couponTrackExportDownloadDisable: true }) 
    }

    api.getResponse(this.props.user.accessToken, url)
    .then((result) => {
      if(result.status === 'success'){
        this.setState({couponTrackExport: result.data, couponTrackExportDownloadDisable: false, errorMsg: ''})
      }
    }).catch((err)=>{
      this.setState({errorMsg: 'Exception.Error in fetching details.'})
    })
  }
  
	render() {

    let displayComponent;
    let ExcelFile = ReactExport.ExcelFile;
    let ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
    let ExcelColumn = ReactExport.ExcelFile.ExcelColumn;
    let allocatedCoupon = this.state.allocatedCoupons
    if(allocatedCoupon) {
      displayComponent = (
        <tbody>
            <tr>
              <td>{allocatedCoupon.certification_type}</td>
              <td>{allocatedCoupon.overall_total}</td>
              <td>{allocatedCoupon.overall_allocated}</td>
              <td>{allocatedCoupon.overall_remaining}</td>
              <td>{allocatedCoupon.updated_at}</td>
            </tr>
        </tbody>
      )
    }

    let couponExportComponent = (
    <GridCell span="4">
      <Button Button dense onClick= {this.handleCouponExport}>Coupon Export</Button>
      <ExcelFile element={<Button disabled={this.state.couponExportdownloadDisable}>Download</Button>}>
      <ExcelSheet data={this.state.couponExport} name="Coupon Export">
        <ExcelColumn label="Coupon Name" value="coupon_name"/>
        <ExcelColumn label="Track Name" value="track_name"/>
        <ExcelColumn label="Total Count" value="total_count"/>
        <ExcelColumn label="Remaining Count" value="available_count"/>
        <ExcelColumn label="Created At" value="created_at"/>
        <ExcelColumn label="Updated At" value="updated_at"/>
      </ExcelSheet>
      </ExcelFile>
    </GridCell>
    )

    let couponTrackExportComponent = (
      <GridCell span="8">
      <Button Button dense onClick= {this.handleCouponTrackExport}>Trackwise Overall Count Export</Button>
      <ExcelFile element={<Button disabled={this.state.couponTrackExportDownloadDisable}>Download</Button>}>
      <ExcelSheet data={this.state.couponTrackExport} name="Coupon Export">
        <ExcelColumn label="Track Id" value="track_id"/>
        <ExcelColumn label="Track Name" value="tq_test_track_name"/>
        <ExcelColumn label="Remaining Count" value="available_count"/>
      </ExcelSheet>
      </ExcelFile>
    </GridCell>
    )

    return (
      <div>
        <Card style={{padding: '25px'}}>
          <Grid>
            <GridCell span="10">
              <Typography use="headline5">Coupon Allocation</Typography>
            </GridCell>
            <GridCell span="2"><Button raised onClick={this.goBack}>Go Back</Button></GridCell>
          </Grid>
          <table>
            <th>Certification Type</th>
            <th>Total Coupons</th>
            <th>Allocated Coupons</th>
            <th>Remaining Coupons</th>
            <th>Updated At</th>
            {displayComponent}
          </table>
        </Card>
        <br/>
        <div>
          <Card style={{padding: '25px'}}>
            <Grid>
              <GridCell span="2">
                <Typography style={{textDecorationLine: 'underline'}} use="headline5">Coupon Export</Typography>
              </GridCell>
              <GridCell span="10" />
              {couponExportComponent}
              {couponTrackExportComponent}
            </Grid>
          </Card>
        </div>
        <GridCell span="12">
          <StatusMessage error_msg = {this.state.errorMsg}/>
        </GridCell>
      </div>
    )
  }
}

function mapStateToProps({user, admin}) {
  return {
    user,
    admin
  }
}

function mapDispatchToProps() {
  return {}
}

export default connect(mapStateToProps, mapDispatchToProps)(AdminCouponAllocationStatus);


// WEBPACK FOOTER //
// ./src/views/admin/AdminCouponAllocationStatus.jsx